import { useState, useEffect } from 'react';

const getWidth = () => window.innerWidth
    || document.documentElement.clientWidth
    || document.body.clientWidth;

const getHeight = () => window.innerHeight
    || document.documentElement.clientHeight
    || document.body.clientHeight;

export const useCurrentSize = (delay = 50) => {
    // save current window width in the state object
    let [width, setWidth] = useState(getWidth());
    let [height, setHight] = useState(getHeight());
    // in this case useEffect will execute only once because
    // it does not have any dependencies.
    useEffect(() => {
        // timeoutId for debounce mechanism
        let timeoutId = null;
        const resizeListener = () => {
            // prevent execution of previous setTimeout
            clearTimeout(timeoutId);
            // change width from the state object after delay milliseconds
            timeoutId = setTimeout(() => {
                setWidth(getWidth());
                setHight(getHeight());
            }, delay);
        };
        // set resize listener
        window.addEventListener('resize', resizeListener);

        // clean up function
        return () => {
            // remove resize listener
            window.removeEventListener('resize', resizeListener);
        }
    }, [delay])

    return {width,height};
}

export default useCurrentSize;